import { render, staticRenderFns } from "./ClubsIntroductions.vue?vue&type=template&id=5331542e&scoped=true"
import script from "./ClubsIntroductions.vue?vue&type=script&lang=js"
export * from "./ClubsIntroductions.vue?vue&type=script&lang=js"
import style0 from "./ClubsIntroductions.vue?vue&type=style&index=0&id=5331542e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331542e",
  null
  
)

export default component.exports